export const ACCESS = '@@ACCESS'
export const ACCESS_REJECTED = `${ACCESS}/ACCESS_REJECTED`
